export const DEFAULT_LOCALE = 'en';

export const LABELS_BY_LOCALES = {
  ar: 'Arabic',
  bg: 'Bulgarian',
  br: 'Brazilian Portuguese',
  ca: 'Catalan',
  cs: 'Czech',
  da: 'Danish',
  de: 'German',
  el: 'Greek',
  en: 'English',
  es: 'Spanish',
  eu: 'Euskera',
  fi: 'Finnish',
  fr: 'French',
  he: 'Hebrew',
  hi: 'Hindi',
  hu: 'Hungarian',
  id: 'Indonesian',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  nb: 'Norwegian Bokmål',
  nl: 'Dutch',
  pl: 'Polish',
  pt: 'Portuguese',
  ru: 'Russian',
  sl: 'Slovenian',
  sv: 'Swedish',
  th: 'Thai',
  tr: 'Turkish',
  vi: 'Vietnamese',
  zh: 'Chinese',
} as const;

export const LOCALES = Object.keys(LABELS_BY_LOCALES);

export const ROUTE_LOCALE_ALIAS_BY_LOCALE: Record<string, string | undefined> = {
  br: 'pt-BR',
};
